// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2adax","index":"styles_index__1bI3Z"};